













































import {Component, Mixins, Prop} from 'vue-property-decorator';
import {CategoryVariants, IArticleCategoryCard} from '@/components/types';
import TranslatedRouter from '@/mixins/TranslatedRouter';
import CardIcon from '@/components/ui/CardIcon.vue';

@Component({
	components: {
		'v-card-icon': CardIcon
	}
})
export default class ContactBox extends Mixins(TranslatedRouter) {
	@Prop({
		default: () => {
			[]
		}
	}) readonly classes?: string[];
	@Prop({default: null}) readonly iconName?: string | null;
	@Prop({required: true}) readonly data: IArticleCategoryCard;

	categoryVariants = CategoryVariants;

	boxCords: DOMRect | null = null;

	$refs: {
		card: HTMLElement
	};

	get classList(): (string | null)[] {
		return [
			'category-card',
			...(this.classes || [])
		]
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
	}

}
